@if (!isInIframe) {
  <header #header></header>
}
<main id="main" role="main" itemprop="mainContentOfPage" sbbFlyingFocus>
  <router-outlet></router-outlet>
</main>
@if (!isInIframe) {
  <footer #footer></footer>
}
